export const footerStyles = {
    footerContainer: {
        backgroundColor: "#e7e9eb",
        bottom: 0,
        left: 0,
        position: "fixed",
        right: 0,
        zIndex: 1,
        minHeight: "1.5rem",
        paddingLeft: "16px",
        paddingRight: "16px",
    },

    footerItem: {
        alignItems: "center",
        color: "#041821a3",
        display: "flex",
        fontFamily: "Roboto Flex, sans-serif",
        fontSize: "0.625rem",
        fontWeight: 600,
        justifyContent: "center",
        lineHeight: "0.75rem",
        textAlign: "center",
    },
    footerLink: {
        alignItems: "center",
        color: "#041821a3",
        cursor: "pointer",
        display: "inline-flex",
        fontFamily: "Roboto Flex, sans-serif",
        fontSize: "0.625rem",
        fontWeight: 600,
        justifyContent: "center",
        lineHeight: "0.75rem",
        outline: "none",
        padding: "0.5rem 0.75rem",
        textDecoration: "none",
        "&:hover": {
            backgroundColor: "#1019241f",
            borderRadius: "0.25rem",
            textDecoration: "none",
        },
    },
}
